// src/redux/slices/lotAndContainerDetailsSlice.ts
import { PayloadAction } from "@reduxjs/toolkit";
import { IBaseDrawerState, createDrawerSlice } from "../createDrawerSlice";

export interface ILotAndContainerDetailsState extends IBaseDrawerState {
    lotId?: number;
    containerId?: number;
}

export const initialStateLotAndContainerDetails: ILotAndContainerDetailsState = {
    id: "",
    show: false,
    lotId: undefined,
    containerId: undefined,
};

const lotAndContainerDetailsSlice = createDrawerSlice({
    name: "lotAndContainerDetails",
    initialState: initialStateLotAndContainerDetails,
    reducers: {
        showLotAndContainerDetails: {
            prepare: (payload: { lotId?: number; containerId?: number }) => {
                let id = "lotAndContainerDetails";
                if (payload.lotId) id += `-lot${payload.lotId}`;
                if (payload.containerId) id += `-container${payload.containerId}`;
                return {
                    payload: {
                        ...payload,
                        id,
                        instanceId: `${id}-${Date.now()}`,
                    },
                };
            },
            reducer: (
                state,
                action: PayloadAction<{
                    id: string;
                    instanceId: string;
                    lotId?: number;
                    containerId?: number;
                }>,
            ) => ({
                ...state,
                id: action.payload.instanceId,
                lotId: action.payload.lotId,
                containerId: action.payload.containerId,
                show: true,
            }),
        },
        hideLotAndContainerDetails: (state) => ({
            ...state,
            show: false,
        }),
    },
});

export const { showLotAndContainerDetails, hideLotAndContainerDetails } =
    lotAndContainerDetailsSlice.actions;

export default lotAndContainerDetailsSlice.reducer;
